export const list = {
  table: {
    id: '固有ID',
    no: 'No.',
    position: '職位',
    workingForm: '勤務形態',
    workingHours: '勤務時間',
    department: '部署',
    code: 'ICCD',
    firstName: '名',
    lastName: '姓',
    name: '氏名',
    kana: 'カナ',
    gender: '性別',
    uid: 'ICカードNo.',
    action: 'アクション',
    language: '言語',
    companyJoinDate: '入社年月日',
    dob: '生年月日',
    update: '編集',
    delete: '削除',
    confirmDelete: '社員情報を削除しますか?',
  },
  pageHeader: {
    title: '社員情報',
    titleEmployeesList: '個人データ登録・編集',
    new: '新規',
    csvImport: 'CSV インポート',
  },
  buttonAction: {
    importAdd: 'インポート（追加）',
    importOverwrite: 'インポート（上書き）',
    export: 'エクスポート',
    update: 'アップデート',
  },
  languages: {
    en: '英語',
    vi: 'ベトナム語',
    th: 'タイ語',
    ja: '日本語',
    cn: '中国語',
  },
}
